import { render, staticRenderFns } from "./PagSeguro.vue?vue&type=template&id=2d0b66f2&"
import script from "./PagSeguro.vue?vue&type=script&lang=js&"
export * from "./PagSeguro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports